<hr />
<div class="container text-center small">
  &copy;  Copyright 2026. All rights reserved.
</div>
